module.exports = __webpack_public_path__ + "static/dog-illustration-82605000735d97460029fe5482e807ca.svg";